<template>
  <Select
    :items="despachantes"
    :selectedItem="selectedItem"
    label="Despachante"
    searchPlaceholder="Buscar despachante"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../mixins/Select.js';

export default {
  mixins: [Select],
  data() {
    return {
      despachantes: [],
    }
  },
  mounted() {
    this.$api.get('/usuario/cadastro/despachantes_aduaneiros').then(({ data }) => {
      this.despachantes = data.despachantes_aduaneiros.map(despachante => ({
        id: despachante.id,
        name: despachante.nome,
      }));

      const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
      this.$renderFiltroSelect(filtroAplicado, this.despachantes, this.selectedItem);
    });
  },
}
</script>